import TriangleDividerVertical from "../../components/triangle/triangle-divider-vertical"
import useMediaQueries from '../../hooks/useMediaQueries'
import authInfinite from "../../assets/icons/auth-infinite.svg"
import BrandLogo from "../../components/brand-logo";
// import { useLayoutEffect } from "react";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { confirmMessageRequest, guestLoginPhone, guestVerification } from "../../assets/api/userActions";
import { redirectGuestToExamOrJoinPage, tryEnterExamWithStoredToken } from "../../assets/utils/redirectAfterGuestLogin";
import { showAttemptJoinErrorSwal } from "../../assets/utils/attemptJoinErrorSwal";
import './index.scss'
import { useEffect } from "react";

const GuestLogin = () => {

    const params = useParams();
    const navigate = useNavigate();

    const [loginPhone, setLoginPhone] = useState("");
    const [loginName, setLoginName] = useState("");
    const [checked, setChecked] = useState(false);
    const [verify, setVerify] = useState();
    /** تا قبل از بررسی توکن ذخیره‌شده، فرم را نشان نده */
    const [checkingSession, setCheckingSession] = useState(true);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const { isAbove922 } = useMediaQueries();

    useEffect(() => {
        let active = true;
        let enteredSession = false;
        (async () => {
            try {
                const v = await guestVerification(params.code);
                if (!active) return;
                if (!v?.validation) {
                    navigate("/service/not-active");
                    return;
                }
                if (!v?.guest) {
                    navigate("/guest/not-active");
                    return;
                }
                setVerify(v);
                const r = await tryEnterExamWithStoredToken(navigate, params.code);
                enteredSession = !!r?.entered;
                if (!active) return;
            } catch {
                /* شبکه / سرور */
            } finally {
                if (active && !enteredSession) {
                    setCheckingSession(false);
                }
            }
        })();
        return () => {
            active = false;
        };
    }, [navigate, params.code])


    function onNavigateToConfirm() {
        window.sessionStorage.setItem("guestInfo", JSON.stringify({ name: loginName, phone: loginPhone }));
        navigate(`/auth/login/guest/confirm/${params.code}`);
    }

    async function resHandler(res) {
        if (!res) {
            Swal.fire({
                icon: "error",
                title: "پاسخی از سرور دریافت نشد",
                confirmButtonText: "باشه"
            });
            return;
        }
        const today = new Date();
        let tomorrow = new Date();
        const setExpireDate = tomorrow.setDate(today.getDate() + 1);
        const token = res?.quizToken || res?.token;
        if (!token) {
            Swal.fire({
                icon: "error",
                title: res?.message || "توکن ورود دریافت نشد",
                confirmButtonText: "باشه"
            });
            return;
        }
        localStorage.setItem("userToken", JSON.stringify({
            ...res, quizToken: token, role: res?.role || "guest", quizCode: params.code, expireDate: setExpireDate
        }));
        // اگر join با خطا مواجه شد، پیام مناسب همان وضعیت را نمایش می‌دهیم
        // (مثلا «زمان آزمون به پایان رسیده است» یا «آزمون غیرفعال است»)
        const result = await redirectGuestToExamOrJoinPage(navigate, params.code, { redirectOnFailure: false });
        if (result.entered) return;
        const joinStatus = result.joinResult?.status;
        const isUnauth = result.joinResult?.message === "Unauthenticated.";
        if (joinStatus && joinStatus !== "joined" && !isUnauth) {
            showAttemptJoinErrorSwal(result.joinResult);
        }
        navigate(`/guest/join/${params.code}`, { replace: true });
    }

    const onSubmitHandler = async (e) => {
        e.preventDefault();
        var regex = new RegExp('^(\\+98|0)?9\\d{9}$');
        if (loginPhone.length !== 11 && loginPhone.length !== 0) {
            Swal.fire({
                icon: "error",
                title: "شماره وارد شده صحیح نمیباشد",
                confirmButtonText: "باشه"
            })
            return
        }
        else if (!loginPhone.length) {
            Swal.fire({
                icon: "error",
                title: "شماره خود را وارد کنید",
                confirmButtonText: "باشه"
            })
            return;
        }
        else if (!regex.test(loginPhone.toString())) {
            Swal.fire({
                icon: "error",
                title: "فرمت شماره وارد شده صحیح نمیباشد",
                confirmButtonText: "باشه"
            })
            return;
        }
        else if (!checked) {
            Swal.fire({
                icon: "error",
                title: "لطفا با شرایط و ضوابط سایت موافقت بفرمایید",
                confirmButtonText: "باشه"
            })

        }
        else {
            if (isSubmitting) return;
            setIsSubmitting(true);
            if (verify.guestDetection) {
                try {
                    const res = await confirmMessageRequest(
                        loginName,
                        loginPhone,
                        params.code
                    );
                    if (res.returnCode === "SUCCESS") {
                        onNavigateToConfirm();
                    } else {
                        Swal.fire({
                            icon: "error",
                            title: res?.message || "ارسال کد تایید ناموفق بود",
                            confirmButtonText: "باشه"
                        });
                    }
                } finally {
                    setIsSubmitting(false);
                }
            }
            else {
                try {
                    const res = await guestLoginPhone({ name: loginName, phone: loginPhone, quiz_code: params.code });
                    await resHandler(res);
                } finally {
                    setIsSubmitting(false);
                }
            }
        }
    }

    function renderSvgBox() {
        if (isAbove922) {
            return (
                <div className="auth-page__svg-box">
                    <object
                        type="image/svg+xml"
                        data={authInfinite}
                        width="523"
                        height="308"
                    >
                        عکس متحرک
                    </object>
                    <BrandLogo width="128" height="39" className="auth-page__brand-logo" />
                </div>
            );
        }
    }

    if (checkingSession) {
        return (
            <main className="auth-page">
                {renderSvgBox()}
                <section className="auth-page__content">
                    <TriangleDividerVertical />
                    <div className="auth-page__form-container">
                        <div className="auth-page--center" style={{ textAlign: "center", padding: "2rem 1rem" }}>
                            <p className="login-description" style={{ marginBottom: 0 }}>
                                در حال بررسی نشست شما…
                            </p>
                        </div>
                    </div>
                </section>
            </main>
        );
    }

    return (
        <main className="auth-page">
            {renderSvgBox()}
            <section className="auth-page__content">
                <TriangleDividerVertical />
                <div className="auth-page__form-container">
                    <div className="auth-page--center">

                        <form
                            onSubmit={onSubmitHandler}
                            className="form-login"
                        >
                            <h4 className="login-title">ورود به صورت مهمان</h4>
                            <p className="login-description">اطلاعات زیر را وارد کنید</p>
                            <input
                                type="text"
                                className="input-style"
                                placeholder="نام و نام خانوادگی"
                                onChange={(e) => {
                                    setLoginName(e.target.value);
                                }}
                            />
                            <input
                                type="number"
                                className="input-style"
                                placeholder="شماره موبایل"
                                onChange={(e) => {
                                    setLoginPhone(e.target.value);
                                }}
                            />
                            <div className="checkbox-input-wrapper">
                                <input type="checkbox" onChange={() => setChecked(!checked)} />
                                <p className="check-title">
                                    با در اختیار قرار گرفتن اطلاعات کاربری خود برای برگزار کننده موافق هستم.
                                </p>
                            </div>
                            <button
                                type="submit"
                                className={`button-login ${isSubmitting ? "button-login--loading" : ""}`}
                                disabled={isSubmitting}
                            >
                                {
                                    verify?.guestDetection ?
                                        (isSubmitting ? "در حال ارسال کد..." : "ثبت و ادامه") :
                                        (isSubmitting ? "در حال ورود..." : "ورود")
                                }

                            </button>
                        </form>
                    </div>
                </div>
            </section>
        </main>

    )
}

export default GuestLogin